<template>
  <ul class="dropdown__list">
    <li v-bind:key="item[bindKey]" v-for="item in items" class="dropdown">
      <slot name="item" v-bind:item="item"></slot>
    </li>
  </ul>
</template>
<script>
export default {
  props: ['items', 'bindKey']
};
</script>
